import { useRef, useState, useCallback } from 'react';
import { imageService } from '../../services/imageService';
import './ImageUpload.css';

export default function ImageUpload({
  label,
  value,
  onChange,
  error,
  disabled = false,
  pendingFile = null
}) {
  const inputRef = useRef(null);
  const [validationError, setValidationError] = useState('');

  const previewUrl = pendingFile ? URL.createObjectURL(pendingFile) : value;
  const displayError = error || validationError;

  const handleInputChange = useCallback((e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const validation = imageService.validateImage(file);
    if (!validation.valid) {
      setValidationError(validation.error);
      return;
    }
    setValidationError('');
    onChange(file);
  }, [onChange]);

  const handleRemove = useCallback((e) => {
    e.stopPropagation();
    setValidationError('');
    onChange(null);
    if (inputRef.current) inputRef.current.value = '';
  }, [onChange]);

  return (
    <div className={`image-upload ${displayError ? 'image-upload--error' : ''}`}>
      {label && <label className="image-upload__label">{label}</label>}

      {previewUrl ? (
        <div
          className={`image-upload__preview-wrap ${!disabled ? 'image-upload__preview-wrap--clickable' : ''}`}
          onClick={!disabled ? () => inputRef.current?.click() : undefined}
          title={!disabled ? 'Click to replace photo' : undefined}
        >
          <img src={previewUrl} alt={`${label || 'Image'} preview`} className="image-upload__preview-img" />
          {!disabled && (
            <button type="button" className="image-upload__remove" onClick={handleRemove} aria-label="Remove image">
              ✕
            </button>
          )}
        </div>
      ) : (
        <button
          type="button"
          className="image-upload__add-btn"
          onClick={() => inputRef.current?.click()}
          disabled={disabled}
          aria-label={`Add ${label || 'image'}`}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" />
            <circle cx="12" cy="13" r="4" />
          </svg>
          Add photo
        </button>
      )}

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        className="image-upload__input"
        onChange={handleInputChange}
        disabled={disabled}
        aria-hidden="true"
      />

      {displayError && (
        <span className="image-upload__error" role="alert">{displayError}</span>
      )}
    </div>
  );
}
